import { OnboardingFormSchema, SsoSignup } from '../../components/Onboarding/types';
import { getErrorMessage } from '../../utils/error';
import { getDocument, setDocument } from '../firestore';

/**
 * Get Onboarding data from Firestore
 * @param id Onboarding record id.
 * @returns A promise that resolves to Onboarding data.
 */
export async function getSignupData(id: string) {
  try {
    if (!id?.length) throw Error('Invalid Onboarding id');

    const signupData = await getDocument<SsoSignup>(`authSession/${id}/signupData/${id}`);
    return signupData;
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Unable to get onboarding data')?.message);
  }
}

/**
 * Set Onboarding data to Firestore.
 * @param id Onboarding record id. - required
 * @param data Onboarding data to be set.
 * @returns A promise that resolves when the document has been set.
 */
export async function setSignupData(id: string, data: OnboardingFormSchema) {
  try {
    return setDocument<OnboardingFormSchema>(`authSession/${id}/signupData/${id}`, data, {
      merge: true,
    });
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Unable to add onboarding data')?.message);
  }
}
